import Logo from "../assets/arshadkh507-logo.png"
import "./Header.css";

export const Header = () => {
  return (
    <header>
        <img src={Logo} alt="arshadkh507 Logo" />
        <a href="/">Home</a>
    </header>
  )
}

